import React from 'react'
import { CrossIcon, Pane } from 'evergreen-ui'
import { FaCheck } from 'react-icons/fa'
import { FaX } from 'react-icons/fa6'
import { Text } from 'evergreen-ui'

const StatusRegister_3 = () => {
  return (
    <>
      <Pane
        color="#ffffff"
        backgroundColor="#ff0000"
        height="100%"
        paddingY={4}
        paddingX={5}
        fontSize={16}
        fontFamily=""
        fontWeight={700}
        marginBottom={8}
        display="flex" alignItems="center" justifyContent="center"
      >
        <Text color="#ffffff" fontWeight={700}>
          <CrossIcon /> ไม่ผ่านการคัดเลือก
        </Text>
      </Pane>
      {/* <Pane
        color="#000000"
        backgroundColor="#686868"
        height="100%"
        paddingY={4}
        paddingX={5}
        fontSize={16}
        fontFamily=""
        fontWeight={700}
        marginBottom={8}
        display="flex" alignItems="center" justifyContent="center"
      >
        <Text color="#ffffff" fontWeight={700}>
          จะเปิดรับสมัครรอบ 2 ตั้งแต่วันที่ 17 ธันวาคม 2568 - 11 มกราคม 2569
        </Text>
      </Pane> */}
    </>

  )
}

export default StatusRegister_3